export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  directions: {
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    diesel_fit: "Shell Diesel Fit",
    hydrogen: "Shell Hydrogen",
    premium_gasoline: "Shell Nitrogen Enriched Gasolines",
    shell_regular_diesel: "Diesel",
    truck_diesel: "Shell ClearFLEX E-85 "
  },
  amenities: {
    partner_loyalty_accepted: "Grocer Loyalty Accepted",
    shop: "C-Store"
  }
}
